import { render } from "./TextForm.vue?vue&type=template&id=dd7c77f4&ts=true"
import script from "./TextForm.vue?vue&type=script&lang=ts"
export * from "./TextForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/TextForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd7c77f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd7c77f4', __exports__)) {
    api.reload('dd7c77f4', __exports__)
  }
  
  module.hot.accept("./TextForm.vue?vue&type=template&id=dd7c77f4&ts=true", () => {
    api.rerender('dd7c77f4', render)
  })

}


export default __exports__